import { styled } from '@mui/material/styles';

export const ControlsContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(1)
}));

export const EditorContainer = styled('div')(({ theme }) => ({
  border: '1px solid #ddd',
  borderRadius: theme.borderRadius.base
}));

// ✅ Transient prop $hidePlaceholder
export const EditorBody = styled('div')(({ theme, $hidePlaceholder }) => ({
  borderTop: '1px solid #ddd',
  cursor: 'text',
  ...($hidePlaceholder && {
    '.public-DraftEditorPlaceholder-root': {
      display: 'none'
    }
  }),
  '.DraftEditor-root': {
    minHeight: '120px',
    padding: theme.spacing(1.5)
  }
}));

export const EditorHeader = styled('div')(() => ({
  display: 'flex'
}));

// ✅ Transient prop $hasFocus for StyledRichText
export const StyledRichText = styled('div')(({ theme, $hasFocus, error, disabled }) => ({
  ...($hasFocus && {
    borderColor: theme.color.primary.main,
    boxShadow: `0px 0px 0px 1px ${error ? theme.color.danger.main : theme.color.primary.main}`
  }),
  ...(error && {
    borderColor: theme.color.danger.main
  }),
  '&:hover': {
    ...(!disabled &&
      !error &&
      !$hasFocus && {
        borderColor: theme.color.grey[700]
      })
  }
}));
